<neo-form-field class="create-email-template-field-container" [subscriptSizing]="subscriptSizing()">
  @if (!hideLabel() && label()) {
    <neo-label>{{ label() }}</neo-label>
  }
  <neo-select
    [required]="required()"
    [errorStateMatcher]="errorStateMatcher"
    [ngModel]="value"
    (ngModelChange)="onSelectChange($event)"
    (openedChange)="openedChange.emit($event)"
    (blur)="onBlur()"
    [placeholder]="placeholder()"
    [disabled]="isDisabled"
    [multiple]="multiple()"
    [attr.aut-id]="autId()"
    [aria-label]="effectiveAriaLabel()"
    [compareWith]="compareValues"
  >
    <!-- Custom trigger template for selected value display -->
    <neo-select-trigger>
      @if (!multiple()) {
        <!-- Single-select: show color circle and label -->
        @if (selectedOption(); as selected) {
          @if (selected.color) {
            <span class="color-circle" [style.background-color]="selected.color" aria-hidden="true"></span>
            <span class="color-label">{{ selected.label }}</span>
          } @else {
            <span>{{ selected.label }}</span>
          }
        }
      } @else {
        <!-- Multi-select: show comma-separated labels or count -->
        @if (multiSelectDisplay(); as display) {
          <span>{{ display }}</span>
        }
      }
    </neo-select-trigger>

    @if (loading()) {
      <!-- First-open fetch: show a spinner inside the panel instead of a
           partial option list, so the panel doesn't visibly grow/reflow when
           the real options arrive. -->
      <neo-option [disabled]="true" [value]="value">
        <div class="select-field__loading">
          <cm-spinner [loading]="true" size="small" />
          <span>Loading…</span>
        </div>
      </neo-option>
    } @else if (optionGroups().length > 0) {
      <!-- Grouped options -->
      @for (group of optionGroups(); track group.label) {
        <neo-optgroup [label]="group.label">
          @for (option of group.options; track option.value) {
            <neo-option [value]="option.value" [disabled]="option.disabled || false">
              @if (option.color) {
                <div class="option-with-color">
                  <span class="color-circle" [style.background-color]="option.color" aria-hidden="true"></span>
                  <span>{{ option.label }}</span>
                </div>
              } @else {
                {{ option.label }}
              }
              @if(option?.subtext) {
                <span neoOptionSubtext>{{ option.subtext }}</span>
              }
            </neo-option>
          }
        </neo-optgroup>
      }
    } @else {
      <!-- Flat options -->
      @for (option of options(); track option.value) {
        <neo-option [value]="option.value" [disabled]="option.disabled || false">
          @if (option.color) {
            <div class="option-with-color">
              <span class="color-circle" [style.background-color]="option.color" aria-hidden="true"></span>
              <span>{{ option.label }}</span>
            </div>
          } @else {
            {{ option.label }}
          }
          @if(option?.subtext) {
            <span neoOptionSubtext>{{ option.subtext }}</span>
          }
        </neo-option>
      }
    }
  </neo-select>
  @if (hint()) {
    <neo-hint>{{ hint() }}</neo-hint>
  }

  <!-- Error messages via reusable component -->
  <cm-field-errors
    [control]="ngControl()?.control || null"
    [label]="label()"
    [customMessages]="errorMessages()"
    [showErrorsWhen]="showErrorsWhen()"
    [hideErrors]="hideErrors()"
    [constraints]="{
      maxlength: null,
      minlength: null,
      min: null,
      max: null
    }"
  />

  <!-- Legacy ng-content projection for backward compatibility -->
  <ng-content />
</neo-form-field>
